import React from 'react'
import { useTranslation } from 'react-i18next'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@ui/v2/Table/Table'

import { formatDate } from '@utils/date.utils'

import { useLuckyDrawHistory } from '../hooks/useLuckyDrawHistory'

import styles from '../LuckyDraw.modal.module.scss'

interface HistoryTabProps {
  campaignId: string
}

export const HistoryTab: React.FC<HistoryTabProps> = ({ campaignId }) => {
  const { results, activityTypes, isLoading } = useLuckyDrawHistory(campaignId)

  const { t } = useTranslation()

  return (
    <div className={styles.historyBox}>
      <Table
        isLoading={isLoading}
        noResults={results.length === 0}
        skeletonRows={5}
        skeletonColumns={3}
        className='historyTable'
      >
        <TableHeader>
          <TableRow>
            <TableHead>{t('luckyDraw.historyTable.date')}</TableHead>
            <TableHead>{t('luckyDraw.historyTable.activity')}</TableHead>
            <TableHead>{t('luckyDraw.historyTable.result')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {results.map((result) => (
            <TableRow key={result.id}>
              <TableCell>{formatDate(result.date, { formatType: 'dd.MM.yy / HH:mm' })}</TableCell>
              <TableCell>
                {activityTypes[result.campaignLuckyDrawActivityType.id] ??
                  result.campaignLuckyDrawActivityType.name}
              </TableCell>
              <TableCell>
                {result.amount === 0 ? result.resultType : `${result.amount} ${result.resultType}`}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
